/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Controller } from 'react-hook-form';
import { InputLabel, DataLine } from 'components/elements';
import TextField from './TextField';

function TextFieldControl({ isEditMode, name, control, type = 'text', labelText, rules = {} }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, ...restField }, fieldState: { error } }) =>
        isEditMode ? (
          <TextField
            error={!!error}
            helperText={error ? error.message : null}
            {...restField}
            type={type}
            label={<InputLabel text={labelText} required={rules.required?.value || rules.required} />}
          />
        ) : (
          <DataLine label={labelText} body={restField.value} />
        )
      }
    />
  );
}

TextFieldControl.propTypes = TextField.propTypes;

export default TextFieldControl;
